import { Empty } from 'antd';
import styled from 'styled-components';

export const StyledEmpty = styled(Empty)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`;

export const StyledPatientInfo = styled.div`
  .patient-info-header {
    padding: 28px 24px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;
    p {
      margin: 0;
    }
  }
  .patient-info-tab {
    padding: 20px 24px;
  }
`;
